import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getBojeDropdown} from '../../api/boje'
import {Option} from '../../models/BojaModel'

// Option type as per the API response

// SektorDropdownProps for the component
interface DropdownProps {
    value?: string | number
    initialValue?: string | number
    onChange?: (name: string, value: any) => void
    errors?: string | undefined
    touched?: boolean
    selectName?: string
    disabled?: boolean
}

const mapDropdown = (data) => {
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
}

const BojaDropdown: React.FC<DropdownProps> = ({
                                                   value,
                                                   initialValue,
                                                   onChange,
                                                   errors,
                                                   touched,
                                                   selectName,
                                                   disabled
                                               }) => {
    const [bojaDropdown, setBojaDropdown] = useState<Array<Option>>([])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [internalValue, setInternalValue] = useState<string | number | null>(initialValue ?? null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBojeDropdown()
                setBojaDropdown(mapDropdown(response.data))
            } catch (error) {
                console.error('Error fetching sektor dropdown data:', error)
            }
        }
        fetchData()
    }, [])

    const finalValue = typeof value !== 'undefined' ? value : internalValue

    return (
        <SearchableSelect
            options={bojaDropdown}
            value={finalValue?.toString() ?? ''}
            onChange={onChange!}
            name={selectName ?? 'Boja'}
            errors={errors}
            placeholder='Odaberi boju...'
            touched={touched}
            disabled={!!disabled}
        />
    )
}

export default BojaDropdown
